import axios from '@/lib/AxApi';

export default {
    async getGlobals()
    {
        try
        {
            const response = await axios.get('/Session/returnJsVars');
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async login(data)
    {
        const response = await axios.post('/Session/loginUser', data);

        return response.data;
    },
    async logout()
    {
        try
        {
            const response = await axios.post('/Session/logOut', {});
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async fetchLanguage(langId)
    {
        try
        {
            const response = await axios.get('/Translator/getTranslationByLangId',
                {
                    params:
              {
                  langId,
              },
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async checkTrans(key)
    {
        try
        {
            await axios.post('/Translator/checkTrans',
                {
                    key,
                });
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async setComponentProp(data)
    {
        try
        {
            const response = await axios.post('/GUIComponents/insertRow', data);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async resetComponentUserView(data)
    {
        try
        {
            const response = await axios.post('/GUIComponents/resetComponentUserView', data);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async getComponentProps()
    {
        try
        {
            const response = await axios.get('/GUIComponents/getProps');
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
